<template>
  <div>
    <div class="card rounded-0">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
            <thead>
            <tr>
              <th colspan="2">
                <div v-if="(dataInFarmer.data || []).length">
                  Showing {{ dataInFarmer.from }} to {{ dataInFarmer.to }} of {{ dataInFarmer.total }} entries
                  <pagination :data="dataInFarmer" @pagination-change-page="getResults"></pagination>
                </div>
              </th>
              <th></th>
              <th>Family Details (Short)</th>
              <th>Contact Details and Address</th>
            </tr>
            </thead>
            <tbody v-if="(dataInFarmer.data || []).length">
            <tr v-for="dataInFarmerEach in dataInFarmer.data" :key="dataInFarmerEach.id">
              <td class="text-nowrap">
                <i v-on:click="openShowPage(dataInFarmerEach.id)"
                   v-bind:class="[lastShowOpenedRecord == dataInFarmerEach.id ? 'btn-info' : '', '']"
                   class="flaticon2-edit">{{ dataInFarmerEach.id }} | {{ dataInFarmerEach.account_holder_organization }}
                </i>
                <br>
                <i v-on:click="deleteRecordAsk(dataInFarmerEach.id)"
                   class="flaticon2-delete">{{ dataInFarmerEach.account_holder_number }}</i>
                <br>
                <span
                    v-if="can_see_all_farmer && dataInFarmerEach.created_by_user != undefined && dataInFarmerEach.created_by_user.name"
                    class="text-uppercase badge mr-1 badge-secondary">
                    {{ dataInFarmerEach.created_by_user.name }}
                </span>
              </td>
              <td>
                <status-change-self-capable
                    v-bind:id="dataInFarmerEach.id"
                    v-bind:status="dataInFarmerEach.status"
                ></status-change-self-capable>
              </td>
              <td>
                <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                              {{ dataInFarmerEach.basic_account_holder }}
                              {{ dataInFarmerEach.basic_account_holder_surname }}
                            </span>
                <div
                    v-if="dataInFarmerEach.basic_account_holder_gender"
                    class="text-uppercase badge mr-1 badge-secondary">
                  {{ dataInFarmerEach.basic_account_holder_gender }}
                </div>
                <div
                    v-if="
                    dataInFarmerEach.basic_account_holder_marriage_status &&
                    dataInFarmerEach.basic_account_holder_marriage_status != 'widow'"
                    class="text-uppercase badge mr-1 badge-secondary">
                  Married:{{ dataInFarmerEach.basic_account_holder_marriage_status }}
                </div>
                <div
                    v-if="dataInFarmerEach.basic_account_holder_marriage_status == 'widow'"
                    class="text-uppercase badge mr-1 badge-secondary">
                  {{ dataInFarmerEach.basic_account_holder_marriage_status }}
                </div>
              </td>
              <td>
                <span class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      v-if="dataInFarmerEach.basic_account_holder_wife"
                >
                              Wife: {{ dataInFarmerEach.basic_account_holder_wife }}
                            </span>
                <span class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      v-if="dataInFarmerEach.basic_account_holder_husband"
                >
                              Husband: {{ dataInFarmerEach.basic_account_holder_husband }}
                            </span>
                <span class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      v-if="dataInFarmerEach.basic_account_holder_brother"
                      style="margin-bottom: 2px;"
                >
                              Brother: {{ dataInFarmerEach.basic_account_holder_brother }}
                              <div
                                  v-if="
                                  dataInFarmerEach.basic_account_holder_brother_marriage_status &&
                                  dataInFarmerEach.basic_account_holder_brother_marriage_status != 'widow'"
                                  class="text-uppercase badge mr-1 badge-secondary">
                                Married:{{ dataInFarmerEach.basic_account_holder_brother_marriage_status }}
                              </div>
                              <div
                                  v-if="dataInFarmerEach.basic_account_holder_brother_marriage_status == 'widow'"
                                  class="text-uppercase badge mr-1 badge-secondary">
                                {{ dataInFarmerEach.basic_account_holder_brother_marriage_status }}
                              </div>
                            </span>
                <span class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      v-if="dataInFarmerEach.basic_account_holder_sister"
                >
                            Sister: {{ dataInFarmerEach.basic_account_holder_sister }}
                            <div
                                v-if="
                                dataInFarmerEach.basic_account_holder_sister_marriage_status &&
                                dataInFarmerEach.basic_account_holder_sister_marriage_status != 'widow'"
                                class="text-uppercase badge mr-1 badge-secondary">
                              Married:{{ dataInFarmerEach.basic_account_holder_sister_marriage_status }}
                            </div>
                            <div
                                v-if="dataInFarmerEach.basic_account_holder_sister_marriage_status == 'widow'"
                                class="text-uppercase badge mr-1 badge-secondary">
                              {{ dataInFarmerEach.basic_account_holder_sister_marriage_status }}
                            </div>
                          </span>
              </td>
              <td>
                <div
                    v-if="dataInFarmerEach.basic_account_holder_address">
                  {{ dataInFarmerEach.basic_account_holder_address }}
                </div>
                <div
                    v-if="dataInFarmerEach.basic_account_holder_district"
                    class="text-uppercase badge mr-1 badge-secondary">
                  {{ dataInFarmerEach.basic_account_holder_district }}
                </div>
                <div
                    v-if="dataInFarmerEach.basic_account_holder_village"
                    class="text-uppercase badge mr-1 badge-secondary">
                  {{ dataInFarmerEach.basic_account_holder_village }}
                </div>
                <div
                    v-if="dataInFarmerEach.basic_account_holder_panchayat"
                    class="text-uppercase badge mr-1 badge-secondary">
                  {{ dataInFarmerEach.basic_account_holder_panchayat }}
                </div>
                <div
                    v-if="dataInFarmerEach.basic_account_holder_taluko"
                    class="text-uppercase badge mr-1 badge-secondary">
                  {{ dataInFarmerEach.basic_account_holder_taluko }}
                </div>
                <br>
                <a v-if="dataInFarmerEach.basic_account_holder_mobile"
                   :href="'tel:'+ dataInFarmerEach.basic_account_holder_mobile"
                   class="float-left"
                   style="margin: 2px;"
                >
                  <i class="icon-xl fas fa-mobile-alt"
                  ></i> {{ dataInFarmerEach.basic_account_holder_mobile }}
                </a>
                <a v-if="dataInFarmerEach.basic_account_holder_whatsapp"
                   class="float-right"
                   :href="'whatsapp://'+ dataInFarmerEach.basic_account_holder_whatsapp"
                >
                  <i class="icon-xl fab fa-whatsapp"
                  ></i> {{ dataInFarmerEach.basic_account_holder_whatsapp }}
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card card-custom gutter-b">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="card-label">
            <div class="font-weight-bolder">
              <div class="text-uppercase">
                {{ $t('Filter') }}
              </div>
            </div>
            <span
                class="text-muted mt-3 font-weight-bold font-size-sm">
              {{ $t('Search data by filling below form') }}
            </span>
          </div>
        </div>
        <div class="card-toolbar">
          <div class="btn-group" role="group" aria-label="">
            <router-link class="btn btn-info btn-xs"
                         :to="{ name: 'farmer-create'}">
              {{ $t("Create") }}
            </router-link>
            <div
                v-on:click="reset_filter_active_data()"
                class="btn btn-danger"
            ><i class="flaticon2-refresh-1"></i>
            </div>
            <download-excel
                v-if="can_see_all_farmer"
                class="btn btn-warning"
                :data="json_data"
                :before-generate="export_filter_active_data"
                :fields="json_fields"
                type="xls"
                name="aranya.xlw"
            >
              Export XLW <i class="flaticon2-download-1"></i>
            </download-excel>
            <download-excel
                v-if="can_see_all_farmer"
                class="btn btn-warning"
                :data="json_data"
                :before-generate="export_filter_active_data"
                :fields="json_fields"
                type="csv"
                name="aranya.csv"
            >
              Export CSV <i class="flaticon2-download-1"></i>
            </download-excel>
          </div>
        </div>
      </div>
      <edit
          v-on:storeData="storeData"
          ref="farmerEdit"
          :filter_active=true></edit>
    </div>
  </div>
</template>
<style>
.pagination {
  margin-top: 10px;
}

.badge-secondary {
  margin: 2px;
}
</style>
<script>
import Swal from 'sweetalert2'
import {FARMER, FARMER_EXPORT} from "@/core/services/store/farmer.module";
import {FARMER_DELETE} from "@/core/services/store/farmer.module";
import pagination from 'laravel-vue-pagination';
import {mapGetters} from "vuex";
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/core/services/store/htmlclass.module";
import Edit from "@/view/pages/Farmer/Edit";
import $ from 'jquery'
import StatusChangeSelfCapable from "@/view/pages/Farmer/statusChangeSelfCapable";

export default {
  name: "farmer",
  components: {
    StatusChangeSelfCapable,
    pagination,
    Edit
  },
  data() {
    return {
      dataInFarmer: {},
      dataInFarmerExport: {},
      json_data: [],
      json_fields: {},
      lastDeletedRecord: {},
      lastShowOpenedRecord: {},
      filter_active: {},
      can_see_all_farmer: false,
      api_data: {
        Farmer: {}
      },
    };
  },
  methods: {
    async getResults(page = 1) {
      let finalSearch = {};
      let filter_active_data = JSON.parse(localStorage.getItem('filter_active_data'));
      if (filter_active_data) {
        for (let key in filter_active_data) {
          if (filter_active_data.hasOwnProperty(key)) {
            if (filter_active_data[key]) {
              finalSearch[key] = filter_active_data[key];
            }
          }
        }
      }
      let payload = {
        search: finalSearch
      };
      payload.page = page;
      await this.$store.dispatch(FARMER, payload);
      this.dataInFarmer = this.getFarmer;
      localStorage.setItem('farmer_list_page', page);
    },
    getPage() {
      this.lastShowOpenedRecord = localStorage.getItem('last_show_opened_record') || 1;
      return localStorage.getItem('farmer_list_page') || 1;
    },
    openShowPage(id) {
      this.$router.push({name: 'farmer-show', params: {id: id}});
    },
    async reset_filter_active_data() {
      await localStorage.removeItem('filter_active_data');
      this.$refs.farmerEdit.api_data = {};
      this.$refs.farmerEdit.api_data.Farmer = {};
      this.api_data.Farmer = {};
      location.reload();
    },
    async export_filter_active_data() {
      await this.$store.dispatch(FARMER_EXPORT);
      this.dataInFarmerExport = this.getFarmerExport;
      var thiser = this;
      this.dataInFarmerExport.data.header.forEach(function (item, index) {
        if (index != 0) {
          thiser.json_fields[item] = index;
        }
      });
      this.json_fields = thiser.json_fields;
      this.json_data = this.dataInFarmerExport.data.row;
    },
    storeData(api_data) {
      this.api_data.Farmer = api_data;
      let thiser = this;
      setTimeout(function () {
        thiser.getResults(thiser.getPage());
      }, 500);
    },
    check_can_see_all_farmer() {
      if (this.$store.state.auth.user.email == 'info@dishatrust.in') {
        return true;
      }
      return false;
    },
    deleteRecordAsk(id) {
      let thiser = this;
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          thiser.deleteRecord(id);
        }
      });
    },
    async deleteRecord(id) {
      await this.$store.dispatch(FARMER_DELETE, {id: id});
      this.lastDeletedRecord = this.getDeletedFarmer;
      if (this.lastDeletedRecord.data != undefined) {
        await Swal.fire(
            "Deleted!",
            "Your file has been deleted.",
            "success"
        )
      }
      await this.getResults(this.getPage());
    },
  },
  async mounted() {
    await this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
    await this.getResults(this.getPage());
    await this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    this.can_see_all_farmer = this.check_can_see_all_farmer();
  },
  updated() {
    this.$refs.farmerEdit.getSingle();
  },
  computed: {
    ...mapGetters([
      "getFarmer",
      "getFarmerExport",
      "getDeletedFarmer",
    ])
  }
};
</script>
